import script from "./MainPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainPage.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__